export { default } from './Speedometer'
